import { createStyles } from '@workday/canvas-kit-styling';
import { WcpStyles } from '@workday/wcp-tokens';
import { getTooltipSurfaceBodyTextColor } from './tooltipSurfaceTokens';

/**
 * Shared tooltip body styling for Canvas Kit inverse tooltip surfaces (Tooltip, OverflowTooltip, TooltipContainer).
 * Uses `WcpStyles.color.fg.inverseException` (#ffffff in both light and dark mode) so foreground stays legible on dark tooltip chrome (DEVEXSITE-3030).
 * Prefer `Canvas.Tooltip`, `Canvas.OverflowTooltip`, or these styles on raw CK primitives rather than unstyled `@workday/canvas-kit-react/tooltip` imports.
 */
const tooltipBodyTextColor = getTooltipSurfaceBodyTextColor(WcpStyles);

export const themedTooltipBodyStyles = createStyles({
  maxWidth: '18.75rem',
  color: tooltipBodyTextColor,
});

/** Popper bodies that use TooltipContainer instead of Tooltip (same inverse surface text rule). */
export const themedTooltipPopperBodyStyles = createStyles({
  color: tooltipBodyTextColor,
});
